<template>
    <footer class="site-footer">
        <p v-if="servicePhone" class="site-footer__line">客服电话：{{ servicePhone }}</p>
        <a
            class="site-footer__record"
            :href="policeRecordHref"
            rel="noopener noreferrer"
            target="_blank"
        >
            <img class="site-footer__icon" :src="policeRecordIcon" alt="公安备案图标" />
            <span>蒙公网安备15010202151777号</span>
        </a>
    </footer>
</template>

<script>
import policeRecordIcon from '../assets/police-record-icon.png'

export default {
    name: 'PublicSiteFooter',
    props: {
        servicePhone: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            policeRecordHref: 'https://beian.mps.gov.cn/#/query/webSearch?code=15010202151777',
            policeRecordIcon
        }
    }
}
</script>

<style scoped>
.site-footer {
    width: min(1440px, calc(100% - 32px));
    margin: 18px auto 24px;
    padding: 14px 16px;
    border-radius: 16px;
    border: 1px solid rgba(148, 163, 184, 0.16);
    background: rgba(255, 255, 255, 0.72);
    color: #64748b;
    display: grid;
    gap: 10px;
    justify-items: center;
    text-align: center;
    box-sizing: border-box;
}

.site-footer__line {
    margin: 0;
    font-size: 14px;
}

.site-footer__record {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #475569;
    font-size: 14px;
    line-height: 1.5;
    text-decoration: none;
    flex-wrap: wrap;
}

.site-footer__record:hover {
    color: #1d4ed8;
}

.site-footer__icon {
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
}

@media (max-width: 768px) {
    .site-footer {
        width: min(100%, calc(100% - 16px));
        margin: 16px auto 20px;
    }

    .site-footer__record {
        font-size: 13px;
    }
}
</style>
